import $ from 'jquery';
// import EdeeshopPopup from 'fg-frontend/plugins/edeeshop-popup/EdeeshopPopup';

// export to window
window.$ = $;
window.jQuery = $;

/**
 * Edeeshop Popup init
 */
// window.edeeshopPopup = new EdeeshopPopup({allowContainerClickClose:true});



// WEBPACK FOOTER //
// ./fe/web-default/src/js/windowExports.js